import React from "react";
import { Leaf, Globe, FlaskConical, Boxes, ShieldCheck, Sparkles } from "lucide-react";

const items = [
    { icon: Leaf, title: "Chemical-free", body: "Zero preservatives, zero additives, zero anti-caking agents. Just produce — milled." },
    { icon: Globe, title: "Export-ready", body: "Phytosanitary, COA, MSDS and HALAL/KOSHER documentation prepared per shipment." },
    { icon: FlaskConical, title: "Custom mesh", body: "80 / 100 / 150 / 200 mesh available. Tell us the application — we dial it in." },
    { icon: Boxes, title: "Retail to industrial", body: "From 250g consumer packs to 25 kg paper sacks — and full container loads." },
    { icon: ShieldCheck, title: "Tested every batch", body: "Microbial, pesticide and heavy-metal panels run on every production lot." },
    { icon: Sparkles, title: "Private label ready", body: "Bring your brand. We dry, pack and ship — the way you want it on the shelf." },
];

const WhyChooseUs = () => {
    return (
        <section data-testid="why-choose-section" className="py-24 md:py-36 bg-sun-bg">
            <div className="container-x">
                <div className="grid grid-cols-12 gap-6 mb-16">
                    <div className="col-span-12 md:col-span-7">
                        <div className="overline mb-4">— Why Ostrich</div>
                        <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] text-sun-ink">
                            Built for buyers
                            <br />
                            who <span className="display-italic text-gradient">read the lab report.</span>
                        </h2>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {items.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <div
                                key={it.title}
                                data-testid={`why-item-${i}`}
                                className="bg-white border border-sun-line rounded-3xl p-8 md:p-10 hover:bg-sun-ink hover:text-sun-bg hover:border-sun-ink transition-all duration-500 group"
                            >
                                <div className="w-12 h-12 rounded-full bg-sunrise flex items-center justify-center text-white mb-8 group-hover:rotate-12 transition-transform">
                                    <Icon className="w-5 h-5" strokeWidth={2} />
                                </div>
                                <h3 className="font-heading text-3xl md:text-4xl leading-[1.05] tracking-tight">
                                    {it.title}
                                </h3>
                                <p className="mt-4 text-sm md:text-base leading-relaxed opacity-80">
                                    {it.body}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
